import cnst from '@/const/const'

const getters = {
  showErrorMessage: (state) => state.showErrorMessage,
  errorMessage: (state) => state.errorMessage,
  errorCallback: (state) => state.errorCallback,
}

const mutations = {
  [cnst.ERROR](state, payload) {
    if (payload === null) {
      state.showErrorMessage = false
      state.errorMessage = null
    } else {
      state.showErrorMessage = true
      state.errorMessage = payload
    }
  },
  [cnst.SHOW_ERROR](state, payload) {
    state.showErrorMessage = !!payload
  },
  [cnst.ERROR_CALLBACK](state, payload) {
    state.errorCallback = payload
  },
}

const state = {
  showErrorMessage: false,
  errorMessage: null,
  errorCallback: null,
}

export default {
  state,
  getters,
  mutations,
}
